import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Form } from 'antd';
import { plainToInstance } from 'class-transformer';
import { useParams } from 'react-router';
import Loader from 'components/AntEnhancement/Loader';
import FinishPackagePrices from 'components/forms/packages/FinishPackagePricesForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { Appointment, Settlement } from 'models';
import PackagesDrawer from 'pages/ShowAppointment/components/drawers/PackagesDrawer';
import services from 'services';
import Header from './components/Header';
import './style.css';
var FinishVisit = function (_a) {
    var t = _a.translate;
    var _b = useState(), appointmentDetails = _b[0], setAppointmentDetails = _b[1];
    var _c = useState(0), packagesDrawerKey = _c[0], setPackagesDrawerKey = _c[1];
    var _d = useState(false), showPackagesDrawer = _d[0], setShowPackagesDrawer = _d[1];
    var id = useParams().id;
    var _e = services.appointmentService.useGetAppointment(Number(id)), appointment = _e.data, isLoading = _e.isLoading;
    var finishAppointment = services.appointmentService.useFinishAppointment().mutate;
    var form = Form.useForm()[0];
    var onClosePackagesDrawer = function () {
        setShowPackagesDrawer(false);
        setPackagesDrawerKey(function (key) { return key + 1; });
    };
    var submit = function (values) {
        appointmentDetails === null || appointmentDetails === void 0 ? void 0 : appointmentDetails.forEach(function (detail) {
            detail.setQuantity(values["used-".concat(detail.getId())]);
            if (!detail.getSettlement())
                detail.setSettlement(new Settlement());
            detail.getSettlement().setAppointmentDetailId(detail.getId());
        });
        if (appointmentDetails)
            appointment === null || appointment === void 0 ? void 0 : appointment.replaceAppointmentDetails(appointmentDetails);
        if (!appointment)
            return;
        finishAppointment({
            appointment: plainToInstance(Appointment, JSON.parse(JSON.stringify(appointment)))
        });
    };
    useEffect(function () {
        var next = appointment === null || appointment === void 0 ? void 0 : appointment.getAppointmentDetails();
        if (!next)
            return;
        if (!appointmentDetails || appointmentDetails.length !== next.length) {
            setAppointmentDetails(next);
        }
    }, [appointment]);
    return (_jsx(Loader, { renderSpinner: isLoading, children: _jsxs("div", { className: "fin", children: [_jsx(Header, { appointment: appointment, onAddPackage: function () { return setShowPackagesDrawer(true); } }), _jsxs(Form, { form: form, layout: "vertical", onFinish: submit, requiredMark: true, children: [_jsx("section", { className: "fin-card", children: _jsxs("table", { className: "fin-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: t('package') }), _jsx("th", { children: t('remainder') }), _jsx("th", { children: t('used') }), _jsx("th", { className: "is-end", children: t('actions') })] }) }), _jsx("tbody", { children: appointmentDetails && appointmentDetails.length > 0 ? (appointmentDetails.map(function (appointmentDetail) { return (_jsx(FinishPackagePrices, { appointmentDetail: appointmentDetail }, "appointmentDetail-".concat(appointmentDetail.getId()))); })) : (_jsx("tr", { children: _jsx("td", { colSpan: 4, className: "fin-empty", children: t('empty') }) })) })] }) }), _jsx("button", { type: "submit", className: "fin-submit", children: t('common:buttons.submit') })] }), appointment && (_jsx(PackagesDrawer, { visiable: showPackagesDrawer, patient: appointment.getPatient(), appointment: appointment, onCloseDrawer: onClosePackagesDrawer }, "Packages-".concat(packagesDrawerKey)))] }) }));
};
export default localeTranslator(FinishVisit, 'finishAppointment');
